import processTermsAndCondition from "../../../../Util/processTermsAndCondition";
import { getAmenitiesByGroupId } from "../../../../Redux/Groups/GroupsActions";
import { addAmenityByGroupId } from "../../../../Redux/Groups/GroupsActions";
import { IoCheckmarkCircle, IoClose, IoCloseCircle } from "react-icons/io5";
import validator, { ValidationField } from "../../../../Util/validator";
import { AppDispatch, RootState } from "../../../../Redux/store";
import imageUrlHelper from "../../../../Util/imageUrlHelper";
import imageToBase64 from "../../../../Util/imageToBase64";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Loading from "../../../Common/Loading/Loading";
import styles from "./AddAmenity.module.scss";
import { CiImageOn } from "react-icons/ci";
import Editor from "react-simple-wysiwyg";

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  groupId: string;
}

function AddAmenity(props: Props) {
  const { setIsOpen, groupId } = props;
  const ref = useRef<HTMLInputElement>(null);
  const dispatch = useDispatch<AppDispatch>();
  const {
    getAllAmenitiesRateTypesData,
    getAllAmenityTypesData,
    addAmenityByGroupIdLoading,
  } = useSelector((state: RootState) => state.groups);
  const { getBuildingsByGroupIdList } = useSelector(
    (state: RootState) => state.buildings,
  );
  const [name, setName] = useState("");
  const [amenityTypeId, setAmenityTypeId] = useState("");
  const [rates, setRates] = useState("");
  const [rateTypeId, setRateTypeId] = useState("");
  const [rule, setRule] = useState("");
  const [lockId, setLockId] = useState("");
  const [image, setImage] = useState<File | string | null>(null);
  const [isActive, setIsActive] = useState("true");
  const [requiredBooking, setRequiredBooking] = useState(false);
  const [termsAndConditions, setTermsAndConditions] = useState("");
  const [doorName, setDoorName] = useState("");
  const [refundPercentage, setRefundPercentage] = useState("");
  const [isGuest, setIsGuest] = useState(false);
  const [doorId, setDoorId] = useState("");
  const [buildingId, setBuildingId] = useState("");
  const [panelId, setPanelId] = useState("");
  const [isParkingTypeSelected, setIsParkingTypeSelected] = useState(false);
  const [noOfCars, setNoOfCars] = useState("");
  const [costPerCar, setCostPerCar] = useState("");
  const [noOfBicycles, setNoOfBicycles] = useState("");
  const [costPerBicycle, setCostPerBicycle] = useState("");
  const [errors, setErrors] = useState<{
    name: string;
    amenityTypeId: string;
    rates: string;
    rateTypeId: string;
    rule: string;
    lockId: string;
    isActive: string;
    image: string;
    termsAndConditions: string;
    doorName: string;
    buildingId: string;
    refundPercentage: string;
    isGuest: boolean;
    doorId: string;
    panelId: string;
    noOfCars: string;
    costPerCar: string;
    noOfBicycles: string;
    costPerBicycle: string;
  }>({
    name: "",
    amenityTypeId: "",
    rates: "",
    rateTypeId: "",
    rule: "",
    lockId: "",
    isActive: "",
    image: "",
    termsAndConditions: "",
    doorName: "",
    buildingId: "",
    doorId: "",
    panelId: "",
    refundPercentage: "",
    isGuest: false,
    noOfCars: "",
    costPerCar: "",
    noOfBicycles: "",
    costPerBicycle: "",
  });

  const addAmenityHandler = async () => {
    let fieldsArray: ValidationField[] = [
      {
        key: "name",
        value: name,
        type: "text",
      },
      {
        key: "amenityTypeId",
        value: amenityTypeId,
        type: "text",
      },

      {
        key: "rates",
        value: rates,
        type: "text",
      },

      {
        key: "rateTypeId",
        value: rateTypeId,
        type: "text",
      },

      {
        key: "rule",
        value: rule,
        type: "text",
      },

      {
        key: "lockId",
        value: lockId,
        type: "text",
      },

      {
        key: "isActive",
        value: isActive,
        type: "text",
      },

      {
        key: "image",
        value: image,
        type: "file",
      },

      {
        key: "doorName",
        value: doorName,
        type: "text",
      },
      {
        key: "isGuest",
        value: isGuest.toString(),
        type: "text",
      },
      {
        key: "buildingId",
        value: buildingId,
        type: "text",
      },
    ];

    if (requiredBooking) {
      fieldsArray.push(
        {
          key: "termsAndConditions",
          value: termsAndConditions,
          type: "editor",
        },
        {
          key: "refundPercentage",
          value: refundPercentage,
          type: "numberOnly",
          range: "1-100",
        },
      );
    }
    if (isParkingTypeSelected) {
      fieldsArray.push({
        key: "termsAndConditions",
        value: termsAndConditions,
        type: "editor",
      });
      fieldsArray.push({
        key: "noOfCars",
        value: noOfCars,
        type: "numberOnly",
      });
      fieldsArray.push({
        key: "costPerCar",
        value: costPerCar,
        type: "numberOnly",
      });
      fieldsArray.push({
        key: "noOfBicycles",
        value: noOfBicycles,
        type: "numberOnly",
      });
      fieldsArray.push({
        key: "costPerBicycle",
        value: costPerBicycle,
        type: "numberOnly",
      });
    }
    const { errors: fieldsErrors, isValid } = validator(fieldsArray);

    setErrors({ ...errors, ...fieldsErrors });
    if (isValid) {
      if (!addAmenityByGroupIdLoading && groupId) {
        const successHandler = () => {
          setIsOpen(false);
          dispatch(
            getAmenitiesByGroupId({
              groupId: groupId,
            }),
          );
        };
        const imagebase64 = await imageToBase64(image);
        dispatch(
          addAmenityByGroupId({
            groupId: groupId,
            name: name,
            amenityTypeId: amenityTypeId,
            rates: rates,
            rateTypeId: rateTypeId,
            rule: rule,
            lockId: lockId,
            image: imagebase64,
            isActive: isActive === "true" ? true : false,
            requiresBooking: requiredBooking,
            terms: processTermsAndCondition(termsAndConditions),
            doorName: doorName,
            doorId: doorId || "0",
            panelId: panelId || "0",
            nonRefundPercent: refundPercentage || "0",
            isGuest: isGuest,
            noOfCars: noOfCars || "0",
            costPerCar: costPerCar || "0",
            noOfBicycles: noOfBicycles || "0",
            costPerBicycle: costPerBicycle || "0",
            buildingId: buildingId,
            successHandler,
          }),
        );
      }
    }
  };

  useEffect(() => {
    const amenityType = getAllAmenityTypesData?.find(
      (type) =>
        // eslint-disable-next-line eqeqeq
        type?.amenityTypeId == amenityTypeId ||
        type?.amenityTypeId === amenityTypeId,
    );
    setIsParkingTypeSelected(
      amenityType?.amenityTypeName?.toLowerCase() === "parking",
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [amenityTypeId]);

  return (
    <div className={styles.mainContainer}>
      <div className={styles.headingContainer}>
        <h1 className={styles.heading}>Add Amenity</h1>
      </div>
      <form className={styles.formContainer}>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Amenity Title</p>
          <input
            type="text"
            className={styles.input}
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <p className={styles.error}>{errors.name}</p>
        </div>
        <div className={styles.doubleInputContainer}>
          <div className={styles.inputContainer}>
            <p className={styles.label}>Type</p>
            <select
              className={styles.input}
              value={amenityTypeId}
              onChange={(e) => setAmenityTypeId(e.target.value)}
            >
              <option value="">Select Type</option>
              {getAllAmenityTypesData?.map((type, i: number) => (
                <option key={i} value={type?.amenityTypeId}>
                  {type?.amenityTypeName}
                </option>
              ))}
            </select>
            <p className={styles.error}>{errors.amenityTypeId}</p>
          </div>
          <div className={styles.inputContainer}>
            <p className={styles.label}>Lock ID</p>
            <input
              type="text"
              className={styles.input}
              value={lockId}
              onChange={(e) => setLockId(e.target.value)}
            />
            <p className={styles.error}>{errors.lockId}</p>
          </div>
        </div>
        <div className={styles.textAreaContainer}>
          <p className={styles.label}>Description/Rules</p>
          <textarea
            className={styles.textArea}
            value={rule}
            onChange={(e) => setRule(e.target.value)}
            rows={4}
          />
          <p className={styles.error}>{errors.rule}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Status</p>
          <select
            className={styles.input}
            value={isActive}
            onChange={(e) => setIsActive(e.target.value)}
          >
            <option value={"true"}>Active</option>
            <option value={"false"}>Inactive</option>
          </select>
          <p className={styles.error}>{errors.isActive}</p>
        </div>

        <div className={styles.inputContainer}>
          <p className={styles.label}>Building</p>
          <select
            className={styles.input}
            value={buildingId}
            onChange={(e) => setBuildingId(e.target.value)}
          >
            {!buildingId && <option value="">Select Building</option>}
            {getBuildingsByGroupIdList?.map((building: any, i: number) => (
              <option key={i} value={building?.buildingId}>
                {building?.buildingName}
              </option>
            ))}
          </select>
          <p className={styles.error}>{errors.buildingId}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Is Guest</p>
          <select
            className={styles.input}
            value={isGuest.toString()}
            onChange={(e) =>
              setIsGuest(e.target.value === "true" ? true : false)
            }
          >
            <option value={"true"}>True</option>
            <option value={"false"}>False</option>
          </select>
          <p className={styles.error}>{errors.isGuest}</p>
        </div>
        <div className={styles.doubleInputContainer}>
          <div className={styles.inputContainer}>
            <p className={styles.label}>Rate Type</p>
            <select
              className={styles.input}
              value={rateTypeId}
              onChange={(e) => setRateTypeId(e.target.value)}
            >
              <option value="">Select Rate Type</option>
              {getAllAmenitiesRateTypesData?.map((type, i: number) => (
                <option key={i} value={type?.rateTypeId}>
                  {type?.rateTypeName}
                </option>
              ))}
            </select>
            <p className={styles.error}>{errors.rateTypeId}</p>
          </div>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Door Name</p>
          <input
            type="text"
            className={styles.input}
            value={doorName}
            onChange={(e) => setDoorName(e.target.value)}
          />
          <p className={styles.error}>{errors.doorName}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Door ID</p>
          <input
            type="text"
            className={styles.input}
            value={doorId}
            onChange={(e) => {
              if (/^\d*$/.test(e.target.value)) {
                setDoorId(e.target.value);
              }
            }}
          />
          <p className={styles.error}>{errors.doorId}</p>
        </div>
        <div className={styles.inputContainer}>
          <p className={styles.label}>Panel ID</p>
          <input
            type="text"
            className={styles.input}
            value={panelId}
            onChange={(e) => {
              if (/^\d*$/.test(e.target.value)) {
                setPanelId(e.target.value);
              }
            }}
          />
          <p className={styles.error}>{errors.panelId}</p>
        </div>
        <div className={styles.priceInputContainer}>
          <p className={styles.label}>Rates</p>
          <div className={styles.inputContainer}>
            <p className={styles.currency}>$</p>
            <input
              type="text"
              className={styles.input}
              value={rates}
              onChange={(e) => {
                const value = e.target.value;
                if (/^\d*\.?\d{0,2}$/.test(value)) {
                  setRates(value);
                }
              }}
            />
          </div>
          <p className={styles.error}>{errors.rates}</p>
        </div>
        {isParkingTypeSelected && (
          <React.Fragment>
            <div className={styles.inputContainer}>
              <p className={styles.label}>No of Cars</p>
              <input
                type="text"
                className={styles.input}
                value={noOfCars}
                onChange={(e) => {
                  if (/^\d*$/.test(e.target.value)) {
                    setNoOfCars(e.target.value);
                  }
                }}
              />
              <p className={styles.error}>{errors.noOfCars}</p>
            </div>
            <div className={styles.priceInputContainer}>
              <p className={styles.label}>Cost per Car</p>
              <div className={styles.inputContainer}>
                <p className={styles.currency}>$</p>
                <input
                  type="text"
                  className={styles.input}
                  value={costPerCar}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*\.?\d{0,2}$/.test(value)) {
                      setCostPerCar(value);
                    }
                  }}
                />
              </div>
              <p className={styles.error}>{errors.costPerCar}</p>
            </div>
            <div className={styles.inputContainer}>
              <p className={styles.label}>No of Bicycles</p>
              <input
                type="text"
                className={styles.input}
                value={noOfBicycles}
                onChange={(e) => {
                  if (/^\d*$/.test(e.target.value)) {
                    setNoOfBicycles(e.target.value);
                  }
                }}
              />
              <p className={styles.error}>{errors.noOfBicycles}</p>
            </div>
            <div className={styles.priceInputContainer}>
              <p className={styles.label}>Cost per Bicycle</p>
              <div className={styles.inputContainer}>
                <p className={styles.currency}>$</p>
                <input
                  type="text"
                  className={styles.input}
                  value={costPerBicycle}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*\.?\d{0,2}$/.test(value)) {
                      setCostPerBicycle(value);
                    }
                  }}
                />
              </div>
              <p className={styles.error}>{errors.costPerBicycle}</p>
            </div>
          </React.Fragment>
        )}
        {requiredBooking && (
          <div className={styles.inputContainer}>
            <p className={styles.label}>Non-Refund Percentage</p>
            <input
              type="text"
              className={styles.input}
              value={refundPercentage}
              onChange={(e) => setRefundPercentage(e.target.value)}
            />
            <p className={styles.error}>{errors.refundPercentage}</p>
          </div>
        )}

        <div className={styles.requiredBookingContainer}>
          <div
            className={styles.requiredBookingIconContainer}
            onClick={() => setRequiredBooking(!requiredBooking)}
          >
            {requiredBooking ? (
              <IoCheckmarkCircle
                className={styles.iconNotRequiredBooking}
                size={20}
              />
            ) : (
              <IoCloseCircle className={styles.iconRequiredBooking} size={20} />
            )}
          </div>
          <div className={styles.requiredBookingLabelContainer}>
            <p className={styles.label}>Required Booking?</p>
          </div>
        </div>
        {(requiredBooking || isParkingTypeSelected) && (
          <div className={styles.inputContainer}>
            <p className={styles.label}>Terms and Conditions</p>
            <Editor
              className={styles.termsInput}
              value={termsAndConditions}
              onChange={(e) => setTermsAndConditions(e.target.value)}
            />
            <p className={styles.error}>{errors.termsAndConditions}</p>
          </div>
        )}
        <div className={styles.imageInputContainer}>
          <p className={styles.label}>Amenity Image</p>
          <input
            className={styles.imageInput}
            type="file"
            hidden
            ref={ref}
            accept="image/*"
            value={""}
            onChange={(e) => setImage(e.target.files?.[0] || null)}
          />
          {image ? (
            <div className={styles.inputImageContainer}>
              <img
                className={styles.inputImage}
                src={imageUrlHelper(image)}
                alt="Building"
              />
              <div className={styles.iconContainer}>
                <IoClose
                  className={styles.icon}
                  onClick={() => setImage(null)}
                />
              </div>
            </div>
          ) : (
            <div
              className={styles.imageInputBox}
              onClick={() => ref.current?.click()}
            >
              <div className={styles.iconContainer}>
                <CiImageOn className={styles.icon} />
              </div>
              <div className={styles.labelContainer}>
                <p className={styles.label}>Upload Image</p>
              </div>
            </div>
          )}
          <p className={styles.error}>{errors.image}</p>
        </div>

        {addAmenityByGroupIdLoading && <Loading />}
      </form>

      <div className={styles.buttonContainer}>
        <button className={styles.button} onClick={addAmenityHandler}>
          Add
        </button>
        <button className={styles.cancelBtn} onClick={() => setIsOpen(false)}>
          Cancel
        </button>
      </div>
    </div>
  );
}

export default AddAmenity;
